import React from 'react';
import Icon from '../AppIcon';

const CalculationStatus = ({ status, error, onRetry }) => {
  if (status === 'idle') return null;

  const statusConfig = {
    loading: {
      icon: 'Loader2',
      iconClass: 'animate-spin',
      bgColor: 'bg-primary/10',
      textColor: 'text-primary',
      borderColor: 'border-primary/20',
      title: 'กำลังคำนวณแผนภูมิ',
      titleEn: 'Calculating Chart',
      message: 'กรุณารอสักครู่ขณะที่เรากำลังประมวลผลข้อมูลดาวเคราะห์ของคุณ',
      messageEn: 'Please wait while we process your planetary data',
    },
    success: {
      icon: 'CheckCircle2',
      iconClass: '',
      bgColor: 'bg-success/10',
      textColor: 'text-success',
      borderColor: 'border-success/20',
      title: 'คำนวณสำเร็จ',
      titleEn: 'Calculation Complete',
      message: 'แผนภูมิดาวเคราะห์ของคุณพร้อมแล้ว',
      messageEn: 'Your astrological chart is ready',
    },
    error: {
      icon: 'AlertCircle',
      iconClass: '',
      bgColor: 'bg-error/10',
      textColor: 'text-error',
      borderColor: 'border-error/20',
      title: 'เกิดข้อผิดพลาด',
      titleEn: 'Calculation Error',
      message: error || 'ไม่สามารถคำนวณแผนภูมิได้ กรุณาลองใหม่อีกครั้ง',
      messageEn: error || 'Unable to calculate chart. Please try again.',
    },
  };

  const config = statusConfig?.[status];

  return (
    <div className={`
      fixed top-20 left-1/2 transform -translate-x-1/2 z-100
      w-full max-w-md mx-4 sm:mx-0
      ${config?.bgColor} ${config?.borderColor}
      border-2 rounded-lg p-4 shadow-brand-xl
      transition-smooth
    `}>
      <div className="flex items-start">
        <div className={`flex-shrink-0 ${config?.textColor}`}>
          <Icon name={config?.icon} size={24} className={config?.iconClass} />
        </div>
        <div className="ml-3 flex-1">
          <div className="flex flex-col">
            <h3 className={`text-sm font-heading font-semibold ${config?.textColor}`}>
              {config?.title}
            </h3>
            <p className="text-xs text-muted-foreground mt-0.5">
              {config?.titleEn}
            </p>
          </div>
          <div className="mt-2">
            <p className="text-sm text-foreground">
              {config?.message}
            </p>
            <p className="text-xs text-muted-foreground mt-1">
              {config?.messageEn}
            </p>
          </div>
          {status === 'error' && onRetry && (
            <button
              onClick={onRetry}
              className="mt-3 inline-flex items-center px-3 py-1.5 text-sm font-medium text-error hover:text-error-foreground bg-transparent hover:bg-error border border-error rounded-md transition-smooth"
            >
              <Icon name="RotateCcw" size={16} className="mr-1.5" />
              <span>ลองใหม่อีกครั้ง</span>
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default CalculationStatus;